import { FormattedMessage } from "react-intl";
import { Button, Icon, useTheme } from "@mui/material";

const buttonStyle = {
  fontSize: 12,
  fontWeight: "initial",
  marginLeft: "8px",
  padding: 0,
  textTransform: "none",
  "&:hover": {
    backgroundColor: "transparent",
    cursor: "pointer",
    opacity: 0.8,
  },
  "& .MuiButton-startIcon": {
    marginLeft: "5px",
    marginRight: "5px",
    "span": {
      fontSize: "inherit",
    }
  }
};

const CreateWorkspaceButton = ({ disabled, onClick }) => {
  const theme = useTheme();

  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      startIcon={<Icon className="fa fa-plus" />}
      sx={{ ...buttonStyle, color: theme.palette.common.link }}
    >
      <FormattedMessage id="admin.addNewWorkspace" />
    </Button>
  );
};

export default CreateWorkspaceButton;
